export const STATUSES = ["New", "Contacted", "Follow-up", "Demo", "Trial", "Customer", "Dead"];
export const SIZES = ["Small", "Mid", "Large"];
export const SOURCES = ["Cold Call", "Referral", "Other"];
export const PLATFORMS = ["Facebook", "YouTube", "None", "Other"];
export const METHODS = ["Call", "Email", "Text", "Meeting", "Demo", "Other"];

export const STATUS_STYLE = {
  New: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  Contacted: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
  "Follow-up": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Demo: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/30",
  Trial: "bg-teal-500/15 text-teal-300 border-teal-500/30",
  Customer: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  Dead: "bg-gray-700/40 text-gray-400 border-gray-700",
};

export const testId = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-");

export const fmtDate = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");

export const todayISO = () => {
  const t = new Date();
  return new Date(t.getTime() - t.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const StatusPill = ({ status, id }) => (
  <span data-testid={id} className={"inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold border whitespace-nowrap " + (STATUS_STYLE[status] || STATUS_STYLE.New)}>{status}</span>
);

export const EMPTY_PROSPECT = {
  church_name: "", pastor_name: "", phone: "", email: "", city: "", state: "", denomination: "",
  congregation_size: null, source: null, platforms: [], has_website: false, social_url: "",
  status: "New", last_contact_date: null, next_follow_up_date: null, notes: "",
};
